import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  align?: "left" | "center";
  className?: string;
}

export const SectionHeader = ({
  eyebrow,
  title,
  subtitle,
  align = "left",
  className,
}: SectionHeaderProps) => {
  return (
    <div className={cn("mb-10", align === "center" && "text-center", className)}>
      {eyebrow && (
        <div className={cn(
          "inline-block text-[11px] font-semibold tracking-widest uppercase text-primary mb-3"
        )}>
          {eyebrow}
        </div>
      )}
      <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground">
        {title}
      </h2>
      {subtitle && (
        <p className={cn(
          "mt-4 text-base md:text-lg text-muted-foreground leading-relaxed",
          align === "center" ? "max-w-2xl mx-auto" : "max-w-2xl"
        )}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
